import { createFileRoute, useNavigate } from '@tanstack/react-router';
// Route options read the light search module; the page is code-split with the component.
import { SpacePage } from '@/features/spaces/pages/space-page';
import { SpaceSearchSchema } from '@/features/spaces/search';

/**
 * One tab of a space, the tab being a segment of the address. An unknown tab, or one the reader may
 * not open, falls back to the first tab the space offers them. `?channel=` is the open channel of
 * the Chat tab, `?message=` a message to scroll to.
 */
export const Route = createFileRoute('/_auth/s/$spaceId/$tab')({
  validateSearch: (search) => SpaceSearchSchema.parse(search),
  component: SpaceTabRoute,
});

function SpaceTabRoute() {
  const { spaceId, tab } = Route.useParams();
  const { channel, message } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <SpacePage
      spaceId={spaceId}
      tab={tab}
      channelId={channel}
      messageId={message}
      onTabChange={(next) => {
        void navigate({ to: '/s/$spaceId/$tab', params: { spaceId, tab: next } });
      }}
      onChannelChange={(next) => {
        void navigate({
          to: '/s/$spaceId/$tab',
          params: { spaceId, tab: 'chat' },
          search: { channel: next },
          replace: true,
        });
      }}
    />
  );
}
